import { ContentfulAttachBundle } from '@jbhi-fi/apis/src/contentful/types';
import { BundleModuleProps } from '../../Attach/BundleModule';

export abstract class AttachBundleTransformer {
  static toBundleModuleProps = (entry?: ContentfulAttachBundle): BundleModuleProps => {
    return {
      heading: entry?.fields?.heading ?? '',
      content: entry?.fields?.subtext,
      disclaimer: entry?.fields?.disclaimer,
    };
  };
}
